














































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import {
  IContractCancellationRequest,
  IContractProduct
} from "@/models/contracts";
import { IContract } from "@/models/contracts";

import AdminBrands from "@/mixins/adminBrands";
import CProdMixin from "@/mixins/cProdMixin";
import { CreateElement } from "vue";

@Component({
  components: {
    "cprod-image": () =>
      import("@/components/app/global/contractProducts/cProdImage.vue")
  }
})
export default class CancellationRequestRow extends Mixins(
  AdminBrands,
  CProdMixin
) {
  @Prop({ default: undefined })
  public request?: IContractCancellationRequest;

  // Computed

  public get contract() {
    return this.request?.contract as IContract;
  }

  public get contractId() {
    return this.request?.contract_id;
  }

  public get contractProductId() {
    return this.request?.contract_product_id;
  }

  public get contractProduct() {
    return this.request?.contract_product;
  }

  public get client() {
    return this.contract?.client;
  }

  public get clientId() {
    return this.contract?.client_id;
  }

  public get reason() {
    return this.$_.get(this.request, "reason", "")
      .trim()
      .replace(/[^a-zA-Z\d]$/, "");
  }

  public get cProdSummary() {
    const { summary, type } = this.getCondition(
      this.contractProduct as IContractProduct
    );
    return {
      render: (h: CreateElement) =>
        h(summary, {
          class: [type.replace("is-", "has-text-")]
        })
    };
  }

  // Methods

  public openAdminCancellationModal() {
    return this.$store.dispatch(
      `data/${DataModules.CONTRACTS}/openAdminCancellationModal`,
      {
        props: {
          contractId: this.contractId,
          contractProductId: this.contractProductId
        },
        events: {
          "contract-updated": () => this.$emit("request-updated")
        }
      }
    );
  }
}
